import { useCallback } from "react";
import { CircularProgress } from "@mui/material";
import { GappedBottomActionArea } from "../styles";
import type { PDFData } from "@interfaces";
import { MainActionButton, ShareDocumentsErrorModal } from "@components";
import { useIsScreenBiggerThanSM, useShareOrDownloadFiles } from "@hooks";

interface Props {
  medicalDocumentPDFData: {
    medicalDocumentPDFReadUrl: string;
    medicalDocumentPDFName: string;
  };
}

export const MedicalDocBottomActionArea: React.FC<Props> = ({
  medicalDocumentPDFData: { medicalDocumentPDFReadUrl, medicalDocumentPDFName },
}) => {
  console.log({
    msg: "medicalDocumentPDFData",
    medicalDocumentPDFReadUrl,
    medicalDocumentPDFName,
  });
  const isScreenBiggerThanSM = useIsScreenBiggerThanSM();

  const {
    convertFiles,
    isConvertingFiles,
    shareOrDownloadFilesCallback,
    isDownloadFilesFallbackActive,
    setIsDownloadFilesFallbackActive,
  } = useShareOrDownloadFiles();

  const handleMainActionClick = useCallback(async () => {
    const pdfData: PDFData[] = [
      {
        url: medicalDocumentPDFReadUrl,
        documentName: medicalDocumentPDFName,
      },
    ];

    const pdfFiles = await convertFiles(pdfData);

    await shareOrDownloadFilesCallback(pdfFiles, pdfData);
  }, [
    medicalDocumentPDFReadUrl,
    medicalDocumentPDFName,
    convertFiles,
    shareOrDownloadFilesCallback,
  ]);

  return (
    <>
      <GappedBottomActionArea>
        <MainActionButton onClick={handleMainActionClick} disabled={isConvertingFiles}>
          {isConvertingFiles ? (
            <CircularProgress size={24} color="inherit" />
          ) : isScreenBiggerThanSM ? (
            "Descargar"
          ) : (
            "Compartir"
          )}
        </MainActionButton>
      </GappedBottomActionArea>
      <ShareDocumentsErrorModal
        isOpen={isDownloadFilesFallbackActive}
        onClose={() => setIsDownloadFilesFallbackActive(false)}
      />
    </>
  );
};
